const PIPELINES_URLS = window.PIPELINES_URLS;
const base = require('./base');
const deviceUtilities = require('../utilities/deviceUtilities');
const pageUtilities = require('../utilities/pageUtilities');
const scroll = require('../utilities/scroll');
const urlUtils = require('../utilities/urlUtilities');
var throttle = require('lodash/throttle');
const { processDataLayerCartActionOnProduct } = require('../utilities/datalayerHelpers');
const datalayerPublicHelpers = require('../components/datalayer/publicHelpers');
const cloneProductTileSizesToStickyWrapper = require('./cloneProductTileSizesToStickyWrapper');

const PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS = 'product-info__sizes-info--visible';

/**
 * Shows tile item sizes, only for desktop screen sizes.
 * @param {jQuery} $productTileWrapper Product Tile wrapper
 * @param {jQuery} $associatedSizeInfo size info block to show
 */
function showDesktopTileSizes($productTileWrapper, $associatedSizeInfo) {
    if (!$productTileWrapper || !$associatedSizeInfo) {
        return;
    }

    var productTileWrapperHeight = $productTileWrapper.outerHeight(false);
    var productTileBodyHeight = $productTileWrapper.find('.tile-body').outerHeight(false);
    var productImageHeight = $productTileWrapper.find('.image-container').outerHeight(false);
    var associatedSizeInfoHeight = $associatedSizeInfo.outerHeight(true);
    var sizeInfoMaxHeight = productImageHeight * 0.8; // The percentage of maximum height that the size selector can fill

    if (associatedSizeInfoHeight > sizeInfoMaxHeight) {
        associatedSizeInfoHeight = sizeInfoMaxHeight;
    }

    if (!productTileWrapperHeight
        || !productTileBodyHeight
        || !productImageHeight
        || !associatedSizeInfoHeight
    ) {
        return;
    }

    $associatedSizeInfo.addClass(PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS);
    $associatedSizeInfo.find('button:not([aria-disabled="true"]),a').each((index, value) => {
        // eslint-disable-next-line no-param-reassign
        value.tabIndex = 0;
    });
    $associatedSizeInfo
        .css('bottom', 'inherit')
        .css('max-height', sizeInfoMaxHeight + 'px')
        .css('top', productTileWrapperHeight - productTileBodyHeight - associatedSizeInfoHeight + 'px');
}

/**
 * Closes Tile size selector, in mobile and desktop
 * @param {jQuery} $selector size info block(s) to close
 * @param {string} device Device size selector to close
 * @param {boolean} avoidTransition Remove size selector closing transition
 */
function closeTileSizeSelector($selector, device, avoidTransition) {
    if (device === 'desktop' || (!device && !deviceUtilities.isSmallerThan768())) {
        $selector.css('top', '100%');
        $selector.css('bottom', 'inherit');
    } else if (device === 'mobile' || deviceUtilities.isSmallerThan768()) {
        if (avoidTransition) {
            $selector.addClass('no-transition');
            $selector.css('bottom', '-100%');
            setTimeout(function () {
                $selector.removeClass('no-transition');
            }, 400);
        } else {
            $selector.css('bottom', '-100%');
        }
        scroll.resumePageScroll();
    }
    $selector.removeClass(PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS);
    $selector.find('button,a').each((index, value) => {
        // eslint-disable-next-line no-param-reassign
        value.tabIndex = -1;
    });
}

/**
 * Clones tile item sizes to a common stiky wrapper and
 * shows it, only for mobile screen sizes.
 * @param {Object} params Function params
 * @param {string} params.pid Product ID
 * @param {string} params.productImpressionId The ID of the product impression
 *  (analytics info)
 * @param {jQuery<HTMLDivElement>} params.$productTileSizesInfo Wrapper info
 *  section that contains the different sizes and related info (for instance:
 *  .product-tile__sizes-info)
 */
function showMobileTileSizes({
    pid,
    productImpressionId,
    $productTileSizesInfo
}) {
    if ($('.product-tile-cloned-sizes').length < 1) {
        $('body').append('<div class="product-tile-cloned-sizes"></div>');
    }

    const $destinationContainer = $('.product-tile-cloned-sizes');
    let $clonedSizesInfo = cloneProductTileSizesToStickyWrapper({
        pid,
        productImpressionId,
        $destinationContainer,
        $productTileSizesInfo
    });
    $clonedSizesInfo.addClass(PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS);
    $clonedSizesInfo.find('button:not([aria-disabled="true"]),a').each((index, value) => {
        // eslint-disable-next-line no-param-reassign
        value.tabIndex = 0;
    });
    $clonedSizesInfo
        .css('top', 'inherit')
        .css('bottom', '0');

    scroll.stopPageScroll();
}

/**
 * Add product tile to cart
 * @param {HTMLElement} element Selected size item
 */
function addTileToCartHandler(element) {
    const queryString = $(element).attr('rel');
    if (!queryString) {
        return;
    }
    const $shopTheLookProductContainer = $(element).closest('.shop-the-look-card__product');
    const isShopTheLook = $shopTheLookProductContainer.length > 0;
    let $productContainer = $(element).closest('.product-tile-quick-shop');

    if ($productContainer.length < 1) {
        if (isShopTheLook) {
            $productContainer = $shopTheLookProductContainer;
        } else if (deviceUtilities.isSmallerThan768()) {
            const variationGroupPid = $(element).closest('.product-tile__sizes-info').data('pid');
            $productContainer = $('.product-tile-quick-shop[data-pid="' + variationGroupPid + '"]');
        } else {
            $productContainer = $(element).closest('.product-tile');
        }
    }

    if ($productContainer) {
        $productContainer.spinner().start();
    }

    const requestData = {
        pid: urlUtils.getUrlParameter('pid', queryString),
        quantity: urlUtils.getUrlParameter('quantity', queryString),
        isCartPage: pageUtilities.isCartPage(),
        isEmptyCart: $('.full-cart').length <= 0
    };
    $.ajax({
        url: PIPELINES_URLS.cartAddProduct,
        method: 'POST',
        data: requestData,
        success: function (data) {
            const successData = data;
            successData.isShopTheLook = isShopTheLook;
            successData.isQuickShop = true;
            base.handlePostCartAdd(successData);
            $('body').trigger('product:afterAddToCart', successData);
            processDataLayerCartActionOnProduct(
                data.dataLayerCartActionOnProduct,
                element
            );
            $('body').trigger('closeTileSizeSelector', element);
            base.miniCartReportingUrl(successData.reportingURL);

            if (pageUtilities.isCartPage()) {
                var redemptionsAndCoupons = require('../components/redemptionsAndCoupons').methods;
                redemptionsAndCoupons.resetRedemptionMessages();
                $('body').trigger('cart:UpdateCartPage', data);
            }

            if (element.closest('.minicart-recommendations')) {
                var cartHelpers = require('../cart/cartHelpers');
                cartHelpers.methods.updateMinicartProductsTab();
            }
        },
        error: function (data) {
            base.handlePostCartAdd(data);
        },
        complete: function () {
            if ($productContainer) {
                $productContainer.spinner().stop();
            }
        }
    });
}

/**
 * Closes every product tile size info block
 */
function closeEveryTileSizeInfo() {
    const $allVisibleTileSizeInfo = $(`.${PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS}`);
    closeTileSizeSelector($allVisibleTileSizeInfo, 'mobile');
    closeTileSizeSelector($allVisibleTileSizeInfo, 'desktop');
}

/**
 * Adds the resize event,
 * and then closes all product tiles sizes blocks.
 */
function closeSizesOnResize() {
    window.addEventListener('resize', throttle(function () {
        closeEveryTileSizeInfo();
    }, 300));
}

/**
 * Listen to sizes info external clicks
 */
function listenSizesInfoExternalClick() {
    $('body').on('click', (event) => {
        const isAnySizeInfoVisible = $(`.${PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS}`).length > 0;
        const clickedElementIsOutsideSizeInfo = event.target.closest(`.${PRODUCT_TILE_SIZE_INFO_VISIBLE_CLASS}`) === null;
        const clickedElementIsOutsideSizeInfoTrigger = event.target.closest('.js-product-tile-add-to-cart') === null;
        if (isAnySizeInfoVisible
            && clickedElementIsOutsideSizeInfo
            && clickedElementIsOutsideSizeInfoTrigger
        ) {
            closeEveryTileSizeInfo();
        }
    });
}

/**
 * Listen & handle click on add to cart element on product tiles
 */
function tileAddToCartButton() {
    $('body').on('click', '.js-product-tile-add-to-cart', function () {
        const $quickShopButton = $(this);
        const quickShopButton = $(this).get(0);

        const isUniqueSize = $quickShopButton.data('unique-size');
        const pid = $quickShopButton.data('pid');
        const productImpressionId = datalayerPublicHelpers
            .impressions
            .getProductImpressionIdFromDOM(quickShopButton);
        const $productTileWrapper = $quickShopButton.closest('.product-tile');
        /** @type {jQuery<HTMLDivElement>} Wrapper of the different sizes */
        const $productTileSizesInfo = $productTileWrapper.find('.product-info__sizes-info');

        closeEveryTileSizeInfo();
        if (isUniqueSize || isUniqueSize === 'true') {
            $productTileSizesInfo.find('.js-quickshop-option').trigger('click');
        } else if (deviceUtilities.isSmallerThan768()) {
            showMobileTileSizes({
                pid,
                productImpressionId,
                $productTileSizesInfo
            });
        } else {
            showDesktopTileSizes($productTileWrapper, $productTileSizesInfo);
        }
    });
}

/**
 * Listen & handle click on quickshop enabled option elements
 */
function tileAddToCart() {
    $('body').on('click', '.js-quickshop-option:not(.disabled--unavailable)', function (event) {
        addTileToCartHandler(event.currentTarget);
    });
}

/**
 * Listen & handle click on the tile sizes close element
 */
function closeTileSizeSelectorButton() {
    $('body').on('closeTileSizeSelector', function (event, element) {
        if (deviceUtilities.isSmallerThan768()) {
            closeTileSizeSelector(
                $('.product-tile-cloned-sizes .product-info__sizes-info'),
                'mobile'
            );
        } else if ($(element).length > 0) {
            closeTileSizeSelector(
                $(element).closest('.product-info__sizes-info'),
                'desktop'
            );
        }
    });

    $('body').on('click', '.js-tile-sizes-close', function () {
        $('body').trigger('closeTileSizeSelector', $(this));
    });
}

module.exports = {
    init: function () {
        closeSizesOnResize();
        tileAddToCartButton();
        tileAddToCart();
        closeTileSizeSelectorButton();
        listenSizesInfoExternalClick();
    }
};
